import React from 'react';
import './MicroFrontendError.css';

const MicroFrontendError = ({ name, onRetry }) => {
  return (
    <div className="mf-error-container">
      <div className="mf-error-content">
        <div className="mf-error-icon">⚠️</div>
        <h2>Failed to Load Micro-Frontend</h2>
        <p>The {name} application could not be loaded.</p>
        <div className="mf-error-actions">
          <button onClick={onRetry} className="mf-retry-button">
            Try Again
          </button>
          <button onClick={() => window.history.back()} className="mf-back-button">
            Go Back
          </button>
        </div>
        <details className="mf-error-details">
          <summary>Technical Details</summary>
          <p>
            This micro-frontend may not be running or accessible.
            <br />
            Check that the service is running on the expected port.
          </p>
        </details>
      </div>
    </div>
  );
};

export default MicroFrontendError;
